import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import BASE_URL from "../../components/link/link";
import "./MyOrders.css";

const MyOrders = () => {
  const [orders, setOrders] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    const fetchOrders = async () => {
      try {
        // The server uses the logged-in student from the token; the id in the path is ignored.
        const response = await fetch(`${BASE_URL}/order/getOrder/me`, {
          headers: { authorization: `Bearer ${token}` },
        });
        if (response.status === 401) {
          localStorage.removeItem("token");
          navigate("/login");
          return;
        }
        if (response.status === 404) {
          setOrders([]); // "No orders found" is not an error for the student
          return;
        }
        if (!response.ok) throw new Error("Could not load your orders.");
        setOrders(await response.json());
      } catch (err) {
        setError(err.message || "Could not load your orders.");
      }
    };

    fetchOrders();
  }, [navigate]);

  if (error) return <div className="error-message">{error}</div>;
  if (!orders) return <div className="loading-message">Loading your orders...</div>;

  return (
    <div className="my-orders">
      <h1>My Orders</h1>
      {orders.length === 0 ? (
        <p className="my-orders-empty">
          You have no orders yet. <Link to="/materials">Browse materials</Link>
        </p>
      ) : (
        orders.map((order) => {
          const shipment = order.shipment || {};
          const shipped = shipment.status === "booked";
          return (
            <div className="my-orders-card" key={order._id}>
              <div className="my-orders-head">
                <span>{new Date(order.purchasedDate).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</span>
                <strong>₹{order.totalAmount}</strong>
              </div>
              <ul className="my-orders-items">
                {order.Items.map((item, i) => (
                  <li key={i}>
                    {item.name} <span>x{item.quantity}</span>
                  </li>
                ))}
              </ul>
              <div className="my-orders-ship">
                {shipped ? (
                  <>
                    <div>
                      <span className="my-orders-badge shipped">{shipment.dtdcStatus || "Shipped"}</span>
                      <small>DTDC AWB {shipment.awb}</small>
                    </div>
                    <Link className="my-orders-track" to={`/track-order/${order._id}`}>
                      Track order
                    </Link>
                  </>
                ) : (
                  <span className="my-orders-badge">Order received, being packed</span>
                )}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default MyOrders;
